<section class="participants">
    <div class="sorting-header">
        <button ds-button kind="utility" variant="flat-reduced" size="medium" class="seeall-btn" (click)="toggleExpandCollapse()">
            <vn-icon slot="start" [name]="!isAllexpanded ? 'theme-down' : 'theme-up'" />
            {{ isAllexpanded ? sitecore.horseRacing.raceDetails.CollapseAll : sitecore.horseRacing.raceDetails.ExpandAll }}
        </button>
        <div class="dropdown-sort">
            <ms-dropdown
                [activeOption]="activeOption"
                [isIconTemplate]="true"
                [options]="dropDownItems"
                [popperClass]="'dropdown-popper,horse-racing__sort-dropdown'"
                (optionChange)="orderBy($event.id)"
                (dropdownState)="trackDropdownToggle($event)">
                <vn-icon icon name="sports-greyhounds-sorting" size="16" />
            </ms-dropdown>
        </div>
    </div>
    <div *ngFor="let runner of vm.runners; trackBy: trackParticipant">
        <div class="participant clearfix">
            <div>
                <div class="runner-info">
                    <div class="runner-info-numbers">
                        @if (runner.attributes.raceCardNumber) {
                            <span class="runner-number">{{ runner.attributes.raceCardNumber }}</span>
                        }
                        @if (runner.attributes.drawNumber) {
                            <span class="runner-draw-number chevron-icon">({{ runner.attributes.drawNumber }})</span>
                        }
                        @if (!runner.attributes.isFavorite) {
                            <button ds-button-icon kind="tertiary" variant="flat" size="small" class="sports-icon" (click)="toggleRunnerInfo(runner)">
                                <vn-icon size="12" [name]="vm.expandedParticipant[runner.id] ? 'theme-up' : 'theme-down'" />
                            </button>
                        }
                    </div>
                    <ms-horses-silk [src]="runner.attributes.silkUrl" [description]="runner.attributes.silkDescription" />
                    <div class="name-group runner-info-item">
                        <span class="runner-name">
                            {{ runner.name | msTranslate }}
                        </span>
                        @if (runner.attributes.jockey) {
                            <span class="jockey-name">J: {{ runner.attributes.jockey }}</span>
                        }
                        @if (runner.attributes.trainer) {
                            <span class="trainer-name">T: {{ runner.attributes.trainer }}</span>
                        }
                    </div>
                </div>
                <div class="odds-wrapper">
                    @if (isOptionBet && isEventOption(runner.option)) {
                        <ms-hr-option-pick
                            class="odds-info ms-selectable-pick"
                            [option]="runner.option"
                            [optionGroup]="optionGroup"
                            [event]="fixture"
                            [participant]="runner"
                            [pickType]="pickType"
                            [checkSiblingSelected]="true"
                            [trackingSource]="optionPickTrackingsource"
                            [trackingModuleType]="trackingModuleType"
                            [trackingOptions]="trackingOptions">
                            <div>
                                @if (runner.option.online) {
                                    <span>
                                        @switch (runner.option.participantPriceType) {
                                            @case (priceType.Fixed) {
                                                <span class="option-value">
                                                    {{ runner.option.nativePrice | msNativePriceFormatter }}
                                                </span>
                                            }
                                            @case (priceType.StartingPrice) {
                                                <span>{{ sitecore.betslip.messages.StartingPrice }}</span>
                                            }
                                        }
                                    </span>
                                } @else {
                                    <div class="lock odds-info">
                                        <vn-icon name="theme-locked-i" class="lock-icon" size="12" />
                                    </div>
                                }
                            </div>
                        </ms-hr-option-pick>
                    } @else if (isParticipantOption(runner.option)) {
                        <ms-fixture-pick
                            trackingSource="horseracing_Racecard"
                            class="odds-info ms-selectable-pick"
                            [fixture]="fixture"
                            [participant]="runner"
                            [option]="runner.option"
                            [trackingOptions]="trackingOptions">
                            @if (promotedOptionIdsMap[runner.option.id]) {
                                <ms-promotion-badge class="no-title" />
                            }
                            <ms-racing-fixture-container
                                [runner]="runner"
                                [isSports]="true"
                                [isGreyhounds]="false"
                                [isSpan]="true"
                                [isOption]="true"
                                [isWinMarketOdds]="false"
                                [isActive]="runner.isOptionActive" />
                        </ms-fixture-pick>
                    }
                    <div class="previous-odds">
                        @for (price of runner.priceHistory; track $index) {
                            <span>{{ price | msExternalPriceFormatter }}</span>
                        }
                    </div>
                </div>
            </div>
        </div>
        @if (vm.expandedParticipant[runner.id]) {
            <ms-horse-info [fixtureId]="fixture.id" [participant]="runner" />
        }
    </div>
    @if (vm.nonRunners) {
        <section class="greyhound-non-runners horses-non-runners">
            <span class="non-runners-header">{{ sitecore.horseRacing.raceDetails.NonRunners }}</span>
            <span class="non-runners-list">{{ vm.nonRunners }}</span>
        </section>
    }
</section>
